export default "__VITE_ASSET__0e4577b7__"